export default __webpack_public_path__ + "static/media/company-information.fb106eaa.svg";